import { axiosInstance } from "@/config/axiosInstance";

export const uploadLeads = (employeeKey: string) => async (file: File) => {
  const formData = new FormData();
  formData.append("file", file);

  return axiosInstance
    .post("/lead/upload", formData, {
      headers: {
        authorization: `Bearer ${employeeKey}`,
        "Content-Type": "multipart/form-data",
      },
    })
    .then((response) => response.data);
};

// ? Assign Leads to employee Action
export const takeActionOnLead =
  (employeeKey: string) => (data: { leads: string[] }) =>
    axiosInstance
      .post(
        `/lead/allot`,
        { leads: data?.leads },
        {
          headers: {
            authorization: `Bearer ${employeeKey}`,
            "Content-Type": "application/json",
          },
        }
      )
      .then((response) => response.data);

// ? Assign Leads to employee Action
export const unAssignEmployeeLeads =
  (employeeKey: string) => (data: { leads: string[] }) =>
    axiosInstance
      .post(
        `/lead/deallot`,
        { leads: data?.leads },
        {
          headers: {
            authorization: `Bearer ${employeeKey}`,
            "Content-Type": "application/json",
          },
        }
      )
      .then((response) => response.data);

// ? Assign Leads to employee Action
export const changeStatusOfLead =
  (employeeKey: string) =>
  (data: { lead: string; status: string; comments: string }) =>
    axiosInstance
      .post(`/lead/update/status`, data, {
        headers: {
          authorization: `Bearer ${employeeKey}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => response.data);

// ? Create Lead trigger action
export const createLeadTriggerAction =
  (employeeKey: string) =>
  (data: { lead: string; date: Date; comments: string }) =>
    axiosInstance
      .post(`/lead/trigger/create`, data, {
        headers: {
          authorization: `Bearer ${employeeKey}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => response.data);

// ? Disable Lead trigger action
export const disableLeadTriggerAction =
  (employeeKey: string) => (leadId: string) =>
    axiosInstance
      .post(
        `/lead/trigger/disable/${leadId}`,
        {},
        {
          headers: {
            authorization: `Bearer ${employeeKey}`,
            "Content-Type": "application/json",
          },
        }
      )
      .then((response) => response.data);

// ? Create Lead by Employee
export const createLeadForEmployeeAction =
  (employeeKey: string) =>
  (data: {
    name: string;
    phone: string;
    email: string;
    date?: Date | string;
    broker: string;
    allotToSelf: boolean;
  }) =>
    axiosInstance
      .post<{ success: boolean }>(`/lead/create`, data, {
        headers: {
          authorization: `Bearer ${employeeKey}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => response.data);
